import React from 'react';
import { View, Image, Pressable, StyleSheet } from 'react-native';

import { OPPureComponent, Utils, Navigation, I18n } from '../components';
import ImagePicker from '../components/form/attachments/image_picker';

import { __WEB__, COLOR, FONT, FONT_SIZE, THEME } from '../../constants/styles';

export default class Messages extends OPPureComponent {
  handleMediaSelect = async (imageMessage) => {
    Navigation.showModal({
      screen: 'AddImage',
      title: I18n.t('components.attachments.addImage'),
      passProps: {
        image: imageMessage.image,
        generateThumb: true,
        onAdd: this.props.onImageMessageAdd,
      },
    });
  };

  openImagePicker = () => {
    ImagePicker.selectImage()
      .then(this.handleMediaSelect)
      .catch((e) => {});
  };

  openCamera = () => {
    if (__WEB__) return null;
    Utils.trackEvent('Navigation', 'Load', 'Camera');
    ImagePicker.takePhoto()
      .then(this.handleMediaSelect)
      .catch((e) => {});
  };

  openVideo = () => {
    if (__WEB__) return null;
    Utils.trackEvent('Navigation', 'Load', 'Camera');
    ImagePicker.takeVideo()
      .then(this.handleMediaSelect)
      .catch((e) => {});
  };

  render() {
    const { onGiftPress, showingGifts } = this.props;

    return (
      <View style={styles.accessoryContainer}>
        <Pressable style={styles.accessoryButton} onPress={onGiftPress}>
          <Image
            style={[styles.accessoryIcon, showingGifts ? styles.activeAccessoryIcon : {}]}
            source={require('../../../resources/icon-gift.png')}
          />
        </Pressable>

        {
          <Pressable style={styles.accessoryButton} onPress={this.openImagePicker}>
            <Image
              style={styles.accessoryIcon}
              source={require('../../../resources/icon-photo.png')}
            />
          </Pressable>
        }
        {!__WEB__ && (
          <Pressable style={styles.accessoryButton} onPress={this.openCamera}>
            <Image
              style={styles.accessoryIcon}
              source={require('../../../resources/icon-camera.png')}
            />
          </Pressable>
        )}
        {!__WEB__ && (
          <Pressable style={styles.accessoryButton} onPress={this.openVideo}>
            <Image
              style={styles.accessoryIcon}
              resizeMode="contain"
              source={require('../../../resources/icon-video.png')}
            />
          </Pressable>
        )}
      </View>
    );
  }
}

const styles = StyleSheet.create({
  accessoryContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    borderTopWidth: __WEB__ ? 0 : 1,
    borderColor: COLOR.accent,
  },
  accessoryButton: {
    paddingHorizontal: 15,
    paddingVertical: 12,
  },
  accessoryIcon: {
    width: 24,
    height: 24,
    tintColor: COLOR.textLight,
  },
  activeAccessoryIcon: {
    tintColor: COLOR.emphasis,
  },
});
